import React from "react";

import type { GoodsReceipt, GoodsStatus } from "@/api/receiving";

/** Общие элементы статуса фактической приёмки товара (регистр 1С) — бейдж на
 *  карточках и опции фильтра. Это НЕ фотофиксация: заказ может быть без фото,
 *  но с принятым товаром, и наоборот. */

export const GOODS_FILTER_OPTIONS: { value: GoodsStatus | ""; label: string }[] = [
  { value: "", label: "Все" },
  { value: "full", label: "Принят" },
  { value: "partial", label: "Частично" },
  { value: "none", label: "Не принят" },
];

export function GoodsBadge({ goods }: { goods: GoodsReceipt }): React.ReactElement {
  if (goods.status === "full") {
    return (
      <span className="rounded bg-emerald-100 px-1.5 py-0.5 text-[10px] font-medium text-emerald-700">
        Товар: ✓ принят
      </span>
    );
  }
  if (goods.status === "partial") {
    return (
      <span className="rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-medium text-amber-700">
        Товар: {goods.lines_received} из {goods.lines_total}
      </span>
    );
  }
  return (
    <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-medium text-slate-500">
      Товар: не принят
    </span>
  );
}
